G.BuildEnvironment = {
  testPurchaseSdk: false,
  production: false,
  version: 'DEV',
  APP_ID: 'garden-tales-3',
  // RAVEN_DSN: "https://01b9dd2d3e874a98bc3e6bcf307f772c@sentry.io/1398730",
  GAGK: '472e3ab17e57ac95695e58ca69d0ce6f',
  GASK: '8c9993c2f61ab11a4618411cc618fd6f4f5f47d9',
  isCookOMT: false,

  adPlacementIDs: {
    REWARDED: '243759199843609_250121339207395',
    INTERSTITIAL: '243759199843609_250121699207359',
  },

  adPlacements: {
    skipMission: { adType: 'REWARDED', g_adName: 'skipMission' },
    spinTheDailyWheel: { adType: 'REWARDED', g_adName: 'spinTheDailyWheel' },
    requestMoveHelpWheelSpin: { adType: 'REWARDED', g_adName: 'requestMoveHelpWheelSpin' },
    claimExtraGift: { adType: 'REWARDED', g_adName: 'claimExtraGift' },
    claimAllGifts: { adType: 'REWARDED', g_adName: 'claimAllGifts' },
    achievementGift: { adType: 'REWARDED', g_adName: 'achievementGift' },
    doubleDailyReward: { adType: 'REWARDED', g_adName: 'doubleDailyReward' },
    preLevelBooster: { adType: 'REWARDED', g_adName: 'preLevelBooster' },
    retryChallenge: { adType: 'REWARDED', g_adName: 'retryChallenge' },
    addLife: { adType: 'REWARDED', g_adName: 'addLife' },
    spinTheLevelLostWheel: { adType: 'REWARDED', g_adName: 'spinTheLevelLostWheel' },
    double3hGift: { adType: 'REWARDED', g_adName: 'double3hGift' },
    doubleLevelCoins: { adType: 'REWARDED', g_adName: 'doubleLevelCoins' },
    rewarded: { adType: 'REWARDED', g_adName: 'rewarded' },
    redoMission: { adType: 'REWARDED', g_adName: 'redoMission' },
    chestShuffleRetry: { adType: 'REWARDED', g_adName: 'chestShuffle' },
    firstInterstitialInSession: { adType: 'INTERSTITIAL', g_adName: 'firstInterstitialInSession' },
    secondInterstitialInSession: { adType: 'INTERSTITIAL', g_adName: 'secondInterstitialInSession' },
    interstitial: { adType: 'INTERSTITIAL', g_adName: 'interstitial' },
  },
};
